import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, CardHeader, makeStyles, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        background: 'cyan'
    },
    summary: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular
    },
    cardRoot: {
        margin: theme.spacing(2),
        '&.MuiCardContent-root:last-child': {
            paddingBottom: 0
        }
    },
    cardHeader: {
        '&.MuiCardHeader-content': {
            // background: 'red'
        },
        '&.MuiTypography-h5': {
            fontSize: '0.9rem'
        }
    }
}));

export const FieldWrappper = React.memo((props) => {
    const { children, heading, isAccordion, setState, state, component: Comps } = props;
    let { isCard } = props;
    const classes = useStyles();
    if (!isAccordion) {
        if (isCard === undefined) {
            isCard = true;
        }
    }

    const FinalRender = () => (Comps ? <Comps setState={setState} state={state} /> : children);

    return (
        <>
            {isAccordion ? (
                <Accordion style={props.style ? props.style : { margin: '15px' }}>
                    <AccordionSummary className={classes.summary} expandIcon={<ExpandMore style={{ color: 'white' }} />}>
                        <Typography className={classes.heading}>{heading}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>{FinalRender()}</AccordionDetails>
                </Accordion>
            ) : isCard ? (
                <div style={{ ...props.style, padding: '8px 0' }}>
                    {heading && (
                        <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8, textAlign: 'left' }}>
                            {heading}
                        </Typography>
                    )}
                    <div style={{ textAlign: 'left' }}>{FinalRender()}</div>
                </div>
            ) : (
                <>{FinalRender()}</>
            )}
        </>
    );
});
